/**
 * useUsers (A7) -- who has used MARSAD and what they held.
 *
 * Read-only. The rows are reflected at login (P133/P273), which is the
 * honest limitation the view states rather than hides: a user
 * provisioned in Keycloak who has never signed in does not appear.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";

export interface UserRow {
  id: string;
  username: string;
  display_name: string | null;
  email: string | null;
  last_login_at: string | null;
  is_admin: boolean;
  disabled: boolean;
  positions: string[];
  job_roles: string[];
  modules: string[];
  /** D1 -- their id in the identity provider, so a row can link to
   *  THAT person rather than to the console root. Null for anybody who
   *  has not signed in, where a guessed link would open on the wrong
   *  person. */
  keycloak_subject: string | null;
}

export interface UserList {
  users: UserRow[];
  reflected_at_login: boolean;
}

export function useUsers(): UseQueryResult<UserList, ApiError> {
  return useQuery({
    queryKey: ["admin-users"],
    queryFn: () => api.get<UserList>("/v1/admin/users"),
    staleTime: 30_000,
  });
}
